module.exports = __webpack_public_path__ + "img/Gerhard Hofbauer.481bf44e.jpg";